import React, {Component, createRef} from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Select from "react-select";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import KeywordsInputWrapper from "./KeywordsInputWrapper/KeywordsInputWrapper";
import ExampleGamesInput from "./ExampleGamesInput/ExampleGamesInput";
import DesignProblemsInput from "./DesignProblemsInput/DesignProblemsInput";
import PatternDescriptionInput from "./PatternDescriptionInput/PatternDescriptionInput";
import SeedInput from "./SeedInput/SeedInput";
import RelatedPatternsInput from "./RelatedPatternsInput/RelatedPatternsInput";
import SuggestedExercisesInput from "./SuggestedExercisesInput/SuggestedExercisesInput";
import AuthorInput from "../UI/AuthorInput/AuthorInput";
import './NewPattern.css';
import apiUrl from "../../shared/config";
import {Lock} from "@material-ui/icons";
import {Tooltip} from "@material-ui/core";
import Timer from "../UI/Timer/Timer";
import PlayableConceptInput from "../UI/PlayableConceptInput/PlayableConceptInput";
import SubmitButtonWarning from "../UI/SubmitButtonWarning/SubmitButtonWarning";
import {validStringField} from "../../utils/utils";
import {styleRedShadow} from "../../utils/commonStyles";
import Spinner from 'react-bootstrap/Spinner'
import PatternConditionsInput from "./PatternConditionsInput/PatternConditionsInput";
import PatternConstraintsInput from "./PatternConstraintsInput/PatternConstraintsInput";
import PatternConsequencesInput from "./PatternConsequencesInput/PatternConsequencesInput";
import PatternStateDropdown from "./PatternStateDropdown/PatternStateDropdown";
import ImprovedGroupInput from "../UI/GroupInput/ImprovedGroupInput";
import {cancelEditLock, LockResponses, LockType, requestLockUpdate} from "../../utils/lockUtils";

let timeout = null


class NewPattern extends Component {
    constructor(props) {
        super(props);
        this.state = {
            "has_merged": 0,
            "pattern_id": null,
            "pattern_name": "",
            "pattern_descriptive_title": "",
            "design_problems": [],
            "pattern_description": {description: ""},
            "pattern_image": "",
            "pattern_image_description": "",
            "pattern_confidence": 0,
            "pattern_created_date": "",
            "pattern_edited_date": "",
            "seed_id": "",
            "pattern_state_id": 1,
            "seed": "",
            "exercise_id": null,
            "exercise_name": "",
            "pattern_state_name": "",
            "keywords": [],
            "conditions": [],
            "constraints": [],
            "consequences": [],
            "authors": [],
            "groups": [],
            "related_patterns": [],
            "example_games": [],
            "suggested_exercises": [],
            "secondary_games": [],
            "playable_concept": {game_id: null, description: null},
            "failMessage": "",
            "showFailMessage": false,
            "isLoading": false,
            "keywords_array": []
        };
        this.topRef = createRef();
    }


    componentDidMount() {
        this.setState({'user_id': this.props.userId});
        if (this.props.selectedPatternId === null) {
            this.setState({
                "has_merged": 0,
                "pattern_id": null,
                "pattern_name": "",
                "pattern_descriptive_title": "",
                "design_problems": [],
                "pattern_description": {description: ""},
                "pattern_image": "",
                "pattern_image_description": "",
                "pattern_confidence": 0,
                "pattern_created_date": "",
                "pattern_edited_date": "",
                "seed_id": "",
                "pattern_state_id": 1,
                "seed": "",
                "exercise_id": null,
                "exercise_name" : "",
                "pattern_state_name": "",
                "keywords":[],
                "conditions":[],
                "constraints":[],
                "consequences":[],
                "authors": [],
                "groups": [],
                "related_patterns":[],
                "example_games":[],
                "suggested_exercises":[],
                "secondary_games":[],
                "playable_concept": {game_id: null, description: null},
                "keywords_array": []
            });
        } else {
            axios.get(apiUrl + 'Pattern/getbyid?pattern_id=' + this.props.selectedPatternId + "&token=" + this.props.token)
                .then(response => {
                    this.setState(response.data);
                    this.setState({keywords_array: response.data.keywords ? response.data.keywords.map(keyword => (keyword.keyword_id)) : []});
                });
        }
        timeout = setTimeout(() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }), 50); // this is just a qol thing
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    componentWillUnmount() {
        //console.log('unmount')
        clearTimeout(timeout)
        timeout = null
    }


    lockedText = {
        title: "Update Failed!",
        body: "The attempted update failed because another user is currently editing the pattern. Please copy your changes and close the editing window."
    }

    changedText = {
        title: "Update Failed!",
        body: "The attempted update failed because the pattern has been updated since you started editing. Please copy your changes and close the editing window."
    }

    unknownText = {
        title: "Update Failed!",
        body: "The attempted update failed for an unknown reason. Please copy your changes and close the editing window."
    }

    expiredText = {
        title: "Lock Expired",
        body: "Your editing lock has expired. Please copy your changes and close the editing window."
    }

    canUpdate = () => {
        return validStringField(this.state.pattern_name)
            // could possibly require descriptive name here
            && validStringField(this.state.pattern_description.description)
            && this.hasAValidDesignProblem()
            && this.patternImageDescriptionValid()
            && this.exampleGamesValid()
            && this.playableConceptValid()
            && this.relatedPatternValid()
            && this.suggestedExerciseValid()
            && this.patternSeedValid()
            && this.authorsValid()
    }

    cannotUpdateFailText = () => {
        let fails = []

        !validStringField(this.state.pattern_name) && fails.push("A pattern name is required.");
        !validStringField(this.state.pattern_description.description) && fails.push("A pattern description is required.");
        !this.hasAValidDesignProblem() && fails.push("At least one design problem with a description is required.");
        !this.patternImageDescriptionValid() && fails.push("A caption is required for the pattern image.");
        fails = [...fails, ...this.exampleGamesFailMessages()]
        !this.playableConceptValid() && fails.push("Both a description and a game are required for playable concepts.");
        !this.relatedPatternValid() && fails.push("All fields must be completed for related patterns.");
        !this.suggestedExerciseValid() && fails.push("Complete entries are required for both the exercise and the description fields in suggested exercises.");
        !this.patternSeedValid() && fails.push("Both a title and an exercise are required for a pattern seed.");
        !this.authorsValid() && fails.push("A pattern must have at least one author.");

        return <ul style={{listStyle: "none", margin: 0, padding: 0, color: "red"}}>
            {fails.map((val, index) => <li style={{paddingBottom: 10}} key={"FailWarnings " + index}>{val}</li>)}
        </ul>
    }

    hasAValidDesignProblem = () => {
        return this.state.design_problems
            && this.state.design_problems.filter((problem) => {return problem.deleted !== 1})
                .some(problem => validStringField(problem.design_problem));
    }

    patternImageDescriptionValid = () => {
        return (validStringField(this.state.pattern_image)
            && validStringField(this.state.pattern_image_description))
            || !validStringField(this.state.pattern_image);
    }

    playableConceptValid = () => {
        return !this.state.playable_concept
            || (!this.state.playable_concept.description && !this.state.playable_concept.game_id)
            || (this.state.playable_concept
            && validStringField(this.state.playable_concept.description)
            && Number.isInteger(this.state.playable_concept.game_id));
    }

    exampleGamesValid = () => {
        return this.state.example_games && !this.state.example_games
            .filter((game) => {return game.deleted !== 1}).some(game => {
            return !(!validStringField(game.example_description)
                    && !Number.isInteger(game.game_id)
                    && game.secondary_games.length === 0
                    && game.design_problems.length === 0) // checks if blank
                && (!validStringField(game.example_description)
                    || !Number.isInteger(game.game_id)
                    || game.secondary_games.some(sg => !Number.isInteger(sg.game_id))) // checks if one of the fields is wrong
        });
    }

    exampleGamesFailMessages = () => {
        let arr = [];
        const description = this.state.example_games && this.state.example_games.some(game => {
            return !validStringField(game.example_description)
        });
        const game_id = this.state.example_games && this.state.example_games.some(game => {
            return !Number.isInteger(game.game_id)
        });
        const secondary_game = this.state.example_games && this.state.example_games.some(game => {
            return game.secondary_games.some(sg => !Number.isInteger(sg.game_id))
        });
        description && arr.push("Every example game must have a description.")
        game_id && arr.push("Every example game must have a game selected.")
        secondary_game && arr.push("Every secondary example game must have a game selected.")

        return arr;
    }

    relatedPatternValid = () => {
        return this.state.related_patterns && !this.state.related_patterns.some(related => {
            return (validStringField(related.pattern_relationship)
                || validStringField(related.relationship_description)
                || Number.isInteger(related.related_pattern_id)
                || Number.isInteger(related.relationship_confidence)) && // allows for 100% empty related pattern
            (!validStringField(related.pattern_relationship)
                || !validStringField(related.relationship_description)
                || !Number.isInteger(related.related_pattern_id)
                || !Number.isInteger(related.relationship_confidence)) // checks if any one of the fields is invalid
        })
    }

    suggestedExerciseValid = () => {
        return this.state.suggested_exercises && !this.state.suggested_exercises.some(ex => {
            return !validStringField(ex.suggested_exercise_description)
                || !Number.isInteger(ex.exercise_id)
        })
    }

    patternSeedValid = () => {
        return (!this.state.exercise_id && !this.state.seed)
            || (this.state.exercise_id && Number.isInteger(this.state.exercise_id) && validStringField(this.state.seed));
    }

    authorsValid = () => {
        return this.state.authors && this.state.authors.some(author => Number.isInteger(author.user_id))
    }

    addHandler = () => {
        if (this.canUpdate() && !this.state.isLoading) {
            this.postDataHandler(null);
        }
      //  this.props.cancelAddPattern();
    };

    updateHandler = () => {
        if (this.canUpdate() && !this.state.isLoading) {
            this.setState({isLoading: true});
            requestLockUpdate(this.props.token, this.state.pattern_id, LockType.PATTERN, this.state.pattern_edited_date)
                .then(response => {
                    if (response === LockResponses.LOCK_OWNED || response === LockResponses.LOCK_CREATED) {
                        this.postDataHandler(this.state.pattern_id);
                        //  this.props.cancelAddPattern();
                    } else if (response === LockResponses.LOCK_EXISTS) {
                        this.props.setModalText(this.lockedText);
                        this.props.setModalOnClose(() => {this.setState({isLoading: false})});
                        this.props.modal.current.open();
                    } else {
                        this.props.setModalText(this.changedText);
                        this.props.setModalOnClose(() => {this.setState({isLoading: false})});
                        this.props.modal.current.open();
                    }
                })
                .catch((e) => {
                    console.error(e)
                    this.setState({isLoading: false})
                    this.props.setModalText(this.unknownText);
                    this.props.setModalOnClose(() => {this.setState({isLoading: false})})
                    this.props.modal.current.open();
                })
        }
    };

    keywordsUpdateHandler = (new_value) => {
        if (new_value === null) {
            new_value = [];
        }
        this.setState({keywords_array: new_value.map((keyword) => (keyword.value))});
    };

    conditionsUpdateHandler = (new_value) => {
        if (new_value === null) {
            new_value = [];
        }
        this.setState({conditions: new_value.map((condition) => ({condition_id: condition.value, condition_title: condition.label, condition_description: condition.description}))});
    };

    constraintsUpdateHandler = (new_value) => {
        if (new_value === null) {
            new_value = [];
        }
        this.setState({constraints: new_value.map((constraint) => ({constraint_id: constraint.value, constraint_title: constraint.label, constraint_description: constraint.description}))});
    };

    consequencesUpdateHandler = (new_value) => {
        if (new_value === null) {
            new_value = [];
        }
        this.setState({consequences: new_value.map((consequence) => ({consequence_id: consequence.value, consequence_title: consequence.label, consequence_description: consequence.description}))});
    };

    authorsUpdateHandler = (new_value) => {
        if (new_value === null) {
            this.setState({authors: []})
            return;
        }
        const authors_array = new_value.map((author) => ({user_id: author.value, user_name: author.label}));
        this.setState({authors: authors_array});
    };

    groupsUpdateHandler = (new_value) => {
        if (new_value === null) {
            new_value = [];
        }
        const groups_array = new_value.map((group) => ({group_id: group.value, group_name: group.label}));
        this.setState({groups: groups_array});
    };

    confidenceUpdateHandler = (new_value) => {
        this.setState({pattern_confidence: new_value.value})
    };

    stateUpdateHandler = (id) => {
        if (+id === 5) { // merge state id, see pattern_state table
            // open begin merge modal
            this.props.mergeSelectionModal.open({id: this.state.pattern_id, name: this.state.pattern_name}, null);
            // cancel lock
            if (id) {
                cancelEditLock(this.props.token, this.state.pattern_id, LockType.PATTERN)
                    .then((response) => console.log("Lock", response))
                    .catch(() => console.log("Failed to cancel lock"))
            }
        } else {
            this.setState({pattern_state_id: id});
        }
    };

    exerciseUpdateHandler = (new_value) => {
        this.setState({exercise_id: new_value.value});
        this.setState({exercise_name: new_value.label});
    };

    seedUpdateHandler = (new_value) => {
        this.setState({seed: new_value});
    };

    relatedPatternsUpdateHandler = (new_value) => {
        this.setState({related_patterns: new_value});
    };

    exampleGamesUpdateHandler = (new_value) => {
        this.setState({example_games: new_value});
    };

    designProblemsUpdateHandler = (new_value) => {
        this.setState({design_problems: new_value});
    };

    suggestedExercisesUpdateHandler = (new_value) => {
        this.setState({suggested_exercises: new_value});
    };

    cancelHandler = () => {
        this.props.cancelAddPattern();
    };

    secondaryGamesHandler = (newValue) => {
        this.setState({secondary_games: newValue});
    }

    playableConceptUpdateHandler = (val) => {
        this.setState({playable_concept: val});
    }

    postDataHandler = (pattern_id) => {
        let message = '';
        const post = {
            "pattern_id": pattern_id,
            "pattern_name": this.state.pattern_name,
            "pattern_descriptive_title" : this.state.pattern_descriptive_title,
            "design_problems":this.state.design_problems,
            "pattern_description": this.state.pattern_description,
            "pattern_image": this.state.pattern_image,
            "pattern_image_description": this.state.pattern_image_description,
            "pattern_confidence": this.state.pattern_confidence,
            "pattern_created_date": this.state.pattern_created_date,
            "pattern_edited_date": this.state.pattern_edited_date,
            "pattern_state_id": this.state.pattern_state_id,
            "pattern_state_name": this.state.pattern_state_name,
            "seed_id": this.state.seed_id,
            "seed": this.state.seed,
            "exercise_id": this.state.exercise_id,
            "keywords": this.state.keywords_array ?? [],
            "conditions": this.state.conditions,
            "constraints": this.state.constraints,
            "consequences": this.state.consequences,
            "authors": this.state.authors,
            "groups": this.state.groups,
            "related_patterns": this.state.related_patterns.filter(p => Number.isInteger(p.related_pattern_id)), // filters out blanks
            "example_games": this.state.example_games.filter(g => Number.isInteger(g.game_id)), // filters out blanks
            "suggested_exercises": this.state.suggested_exercises,
            "playable_concept": this.state.playable_concept,
            "has_merged": this.state.has_merged,
        };
        this.setState({isLoading: true})
        axios.post(apiUrl +'Pattern/set?token=' + this.props.token, post)
            .then(response => {
                if (!response.data.message) {
                    this.setState({isLoading: false})
                    this.props.addPattern()
                    this.props.patternSelected(response.data.pattern_id || null)
                } else {
                    message = response.data.message
                    this.setState({failMessage: response.data.message, showFailMessage: true, isLoading: false})
                }
            }).then(() => {
                if (!message) {
        this.setState({
            "has_merged": 0,
            "pattern_id": null,
            "pattern_name": "",
            "pattern_descriptive_title": "",
            "design_problems": [],
            "pattern_description": {description: ""},
            "pattern_image": "",
            "pattern_image_description": "",
            "pattern_confidence": 0,
            "pattern_created_date": "",
            "pattern_edited_date": "",
            "seed_id": "",
            "pattern_state_id": 1,
            "seed": "",
            "exercise_id": null,
            "pattern_state_name": "",
            "keywords":[],
            "conditions":[],
            "constraints":[],
            "consequences":[],
            "authors": [],
            "groups": [],
            "related_patterns":[],
            "example_games":[],
            "suggested_exercises":[],
            "playable_concept": {game_id: null, description: null},
            "failMessage": '',
            "showFailMessage": false,
            "isLoading": false,
            "keywords_array": [],
        })}}).then(() => {if (!message) {this.props.cancelAddPattern() }})
            .catch((e) => {
                console.error(e)
                this.setState({isLoading: false})
                this.props.setModalText(this.unknownText);
                this.props.setModalOnClose(() => {this.setState({isLoading: false})});
                this.props.modal.current.open();
            })
    };


    render () {
        if(!this.props.isAuthenticated && this.props.newPatternOpen) {
            this.cancelHandler();
        }

        const buttonDisabledStyle = {backgroundColor: "darkgray", borderColor: "darkgray", boxShadow: "0 0 2px 4px rgba(255, 10, 10, 0.5)"}

        const submitButton = <SubmitButtonWarning
            placement={'top'}
            token={this.props.token} userId={this.props.userId}
            handleSubmit={this.state.pattern_id ? this.updateHandler : this.addHandler}
            failMessage={this.state.failMessage}
            setShowFailMessage={() => this.setState({showFailMessage: false, isLoading: false})}
            showFailMessage={this.state.showFailMessage}
            postType={{
                lowercase: "patterns",
                capital: "Pattern",
                capitalLowercase: "Patterns",
            }}
            submitButton={
                <Button onClick={() => {
                    this.state.pattern_id ? this.updateHandler() : this.addHandler()
                }} style={this.canUpdate() ? {} : buttonDisabledStyle}>
                    {this.state.pattern_id ? "Update Pattern" : "Add Pattern"}
                </Button>
            }/>

        const addAndUpdateButton = this.state.showFailMessage ?
            submitButton :
                <OverlayTrigger
                    trigger={['hover', 'focus']}
                    rootClose
                    rootCloseEvent="click"
                    placement='top'
                    overlay={<Popover
                        id={"comment-fail-message"}
                        placement={"top-start"}
                    >
                        {!this.canUpdate() && <Popover.Title style={{textAlign: 'center'}}>
                            <span style={{color: "gray", fontWeight: "bold"}}>Pattern Submission Errors</span>
                        </Popover.Title>}
                        <Popover.Content>
                            {this.canUpdate() ? <span style={{color: "green"}}>All required fields are completed.</span> : this.cannotUpdateFailText()}
                        </Popover.Content>
                    </Popover>}
                >
                    <div style={{display: "inline-block", width: "auto"}}>
                        {submitButton}
                    </div>
                </OverlayTrigger>

        let pageTitle = this.state.pattern_id ? "Editing: " + this.state.pattern_name : "Add a Pattern";

        const cancelButton = (<><Button variant="outline-warning" onClick={this.cancelHandler}>Cancel</Button></>);

        const state_dropdown = (
            <PatternStateDropdown patternStateId={this.state.pattern_state_id}
                                  onStateChange={this.stateUpdateHandler.bind(this)}
                                  hasMerged={this.state.has_merged}
                                  setHasMerged={() => this.setState({has_merged: 0})}
            />
        )

        let new_pattern_return = '';
        if (this.props.newPatternOpen) {
            new_pattern_return = (
                <div className="card new-pattern" ref={this.topRef}>
                    <h1 className="card-header">
                        <Row>
                        <div className="col-sm-2">{state_dropdown}</div>
                        <div className="col-sm-8">{pageTitle}</div>
                        <div className="col-sm-2"> {(this.state.pattern_id !== null)
                            ? <span style={{color: "gray", display: "inline-flex", justifyContent: "center", alignItems: "center"}}>
                                <Tooltip title="Pattern Locked for Editing" placement="top">
                                    <Lock />
                                </Tooltip>
                                <Timer
                                    style={{
                                        fontSize: "18px",
                                        marginTop: "17px",
                                        marginRight: "10px",
                                        marginLeft: "5px"
                                    }}
                                    hours={0} minutes={59} seconds={59}
                                    onComplete={() => {
                                        this.props.setModalText(this.expiredText);
                                        this.props.setModalOnClose(() => {this.setState({isLoading: false})});
                                        this.props.modal.current.open();
                                    }}
                                />
                            </span>
                            : ""}</div>
                        </Row>
                    </h1>
                    <div className="card-body">
                        <div className="card-text">
                            <Container>
                                <Row><Col><dl className="row">
                                    <dt className="col-sm-3"><label>Pattern Name<span style={{color: "red"}}> *</span></label></dt>
                                    <dd className="col-sm-9">
                                        <Form.Control
                                            type="text"
                                            // style={styleRedShadow(validStringField(this.state.pattern_name))}
                                            placeholder="Enter a short memorable name for your pattern."
                                            value={this.state.pattern_name}
                                            onChange={(event) => this.setState({pattern_name: event.target.value})}
                                        />
                                    </dd>
                                </dl></Col></Row>
                                <Row><Col><dl className="row">
                                    <dt className="col-sm-3"><label>Descriptive Name</label></dt>
                                    <dd className="col-sm-9">
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter a one sentance description of your pattern."
                                            value={this.state.pattern_descriptive_title}
                                            onChange={(event) => this.setState({pattern_descriptive_title: event.target.value})}
                                        />
                                    </dd>
                                </dl></Col></Row>
                                <Row><Col><DesignProblemsInput designsValid={this.hasAValidDesignProblem} designProblems={this.state.design_problems} designProblemUpdate={this.designProblemsUpdateHandler} userId={this.props.userId} token={this.props.token} pattern_id={this.state.pattern_id}/></Col></Row>
                                <Row><Col><PatternDescriptionInput pattern_description={this.state.pattern_description} descriptionUpdate={(description) => {this.setState({pattern_description: description})}} pattern_id={this.state.pattern_id} token={this.props.token}/>
                                </Col></Row>
                                <Row><Col>
                                    <dl className="row">
                                    <dt className="col-sm-3"><label>Pattern Image</label></dt>
                                    <dd className="col-sm-9">
                                        <Form.Control
                                            style={styleRedShadow(validStringField(this.state.pattern_image)
                                                || (!validStringField(this.state.pattern_image)
                                                    && !validStringField(this.state.pattern_image_description))
                                            )}
                                            type="text"
                                            placeholder="http://www.some.site.com/images/my_image.png"
                                            value={this.state.pattern_image}
                                            onChange={(event) => this.setState({pattern_image: event.target.value})}
                                        />
                                    </dd>
                                </dl></Col></Row>
                                <Row><Col><dl className="row">
                                    <dt className="col-sm-3"><label>Pattern Image Description</label></dt>
                                    <dd className="col-sm-9">
                                        <Form.Control
                                            type="text"
                                            style={styleRedShadow(validStringField(this.state.pattern_image_description)
                                                || (!validStringField(this.state.pattern_image)
                                                    && !validStringField(this.state.pattern_image_description))
                                            )}
                                            placeholder="Describe how your image relates to the pattern."
                                            value={this.state.pattern_image_description}
                                            onChange={(event) => this.setState({pattern_image_description: event.target.value})}
                                        />
                                        <Form.Text className="text-muted">This will be used as alt text and caption.</Form.Text>
                                    </dd>
                                </dl></Col></Row>
                                <Row><Col><dl className="row">
                                    <dt className="col-sm-3"><label>Pattern Confidence</label></dt>
                                    <dd className="col-sm-9">
                                        <Select
                                            options={[
                                                {value: 0, label: 0},
                                                {value: 1, label: 1},
                                                {value: 2, label: 2},
                                                {value: 3, label: 3},
                                                {value: 4, label: 4},
                                                {value: 5, label: 5},
                                                {value: 6, label: 6}
                                            ]}
                                            value={{value: this.state.pattern_confidence, label: this.state.pattern_confidence}}
                                            defaultValue={{value: this.state.pattern_confidence, label: this.state.pattern_confidence}}
                                            onChange={(val) => this.confidenceUpdateHandler(val)}
                                            closeMenuOnSlelect={true}
                                        />
                                    </dd>
                                </dl></Col></Row>
                                <Row><Col><dl className="row">
                                    <dt className="col-sm-3"><label>Author(s)</label></dt>
                                    <dd className="col-sm-9">
                                        <AuthorInput
                                            userId={this.props.userId}
                                            authors_filter={this.state.authors.map(author => author.user_id)}
                                            authorsUpdate={this.authorsUpdateHandler}
                                            updatePage={this.props.updatePage}
                                            closePatternDetails={this.props.closePatternDetails}
                                            patternEdit={true}
                                        />
                                    </dd>
                                </dl></Col></Row>
                                <Row><Col><dl className="row">
                                    <dt className="col-sm-3"><label>Group(s)</label></dt>
                                    <dd className="col-sm-9">
                                        <ImprovedGroupInput
                                            userId={this.props.userId}
                                            groupsFilter={this.state.groups.map(group=> group.group_id)}
                                            groupsUpdate={(val) => this.groupsUpdateHandler(val)}
                                            updatePage={this.props.updatePage}
                                            closePatternDetails={this.props.closePatternDetails}
                                        />
                                    </dd>
                                </dl></Col></Row>
                                <Row><Col><SeedInput
                                    seed={this.state.seed}
                                    seed_id={this.state.seed_id}
                                    exercise_id={this.state.exercise_id}
                                    exercise_name={this.state.exercise_name}
                                    exerciseUpdate={this.exerciseUpdateHandler}
                                    seedUpdate={this.seedUpdateHandler}
                                /></Col></Row>
                                <Row><Col><KeywordsInputWrapper
                                    keywords_filter={this.state.keywords_array}
                                    keywordsUpdate={this.keywordsUpdateHandler}
                                    updatePage={this.props.updatePage}
                                    closePatternDetails={this.props.closePatternDetails}
                                /></Col></Row>
                                <Row><Col><PatternConditionsInput
                                    token={this.props.token}
                                    userId={this.props.userId}
                                    patternConditions={this.state.conditions}
                                    patternConditionsUpdate={this.conditionsUpdateHandler}
                                    updatePage={this.props.updatePage}
                                    closePatternDetails={this.props.closePatternDetails}
                                /></Col></Row>
                                <Row><Col><PatternConstraintsInput
                                    token={this.props.token}
                                    userId={this.props.userId}
                                    patternConstraints={this.state.constraints}
                                    patternConstraintsUpdate={this.constraintsUpdateHandler}
                                    updatePage={this.props.updatePage}
                                    closePatternDetails={this.props.closePatternDetails}
                                /></Col></Row>
                                <Row><Col><PatternConsequencesInput
                                    token={this.props.token}
                                    userId={this.props.userId}
                                    patternConsequences={this.state.consequences}
                                    patternConsequencesUpdate={this.consequencesUpdateHandler}
                                    updatePage={this.props.updatePage}
                                    closePatternDetails={this.props.closePatternDetails}
                                /></Col></Row>
                                <Row><Col><PlayableConceptInput playableConceptUpdate={this.playableConceptUpdateHandler} playableConcept={this.state.playable_concept}/></Col></Row>
                                <Row><Col><ExampleGamesInput exampleGames={this.state.example_games} exampleGamesUpdate={this.exampleGamesUpdateHandler} designProblems={this.state.design_problems.filter((problem) => {return !problem.deleted})} pattern_id={this.state.pattern_id} token={this.props.token}/></Col></Row>
                                <Row><Col><RelatedPatternsInput relatedPatterns={this.state.related_patterns} relatedPatternUpdate={this.relatedPatternsUpdateHandler} token={this.props.token}/></Col></Row>
                                <Row><Col><SuggestedExercisesInput suggestedExercises={this.state.suggested_exercises} suggestedExercisesUpdate={this.suggestedExercisesUpdateHandler}/></Col></Row>
                                <Row>
                                    <Col>
                                        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                            {addAndUpdateButton}
                                            {this.state.isLoading && (
                                                <Spinner
                                                    animation="border"
                                                    style={{ width: 30, height: 30, marginLeft: 16 }}
                                                />
                                            )}
                                        </div>
                                    </Col>
                                    <Col>{cancelButton}</Col>
                                </Row>
                            </Container>
                        </div>
                    </div>
                </div>

            );
        }

        return new_pattern_return;
    }
}

export default NewPattern;